import { memo } from 'react';
import { GoogleLogo } from '@page/icons';
import { Button } from '@page/ui';

interface AuthWithGoogleButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

const AuthWithGoogleButtonBase = ({ disabled, loading, onClick }: AuthWithGoogleButtonProps) => {
  return (
    <Button
      className="w-full"
      variant="secondary"
      size="lg"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      leftIcon={<GoogleLogo className="mr-2" />}
    >
      Continue with Google
    </Button>
  );
};

export const AuthWithGoogleButton = memo(AuthWithGoogleButtonBase);
